// extracted by mini-css-extract-plugin
export var divider = "_ti-0";